import { Http } from '@/lib/http';
export class InterestRateMethodService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/interest-rate-methods/';
  }

  createInterestRateMethod(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }

  updateInterestRateMethod(id, payload) {
    return this.httpClient().patch(`${this.endpoint}${id}`, payload);
  }

  fetchInterestRateMethod(id) {
    return this.httpClient().get(`${this.endpoint}${id}`);
  }

  fetchAllInterestRateMethods() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  deleteInterestRateMethod(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
}
